import { render, staticRenderFns } from "./PlanningBoardSettings.vue?vue&type=template&id=686f2bd1&scoped=true&"
import script from "./PlanningBoardSettings.vue?vue&type=script&lang=ts&"
export * from "./PlanningBoardSettings.vue?vue&type=script&lang=ts&"
import style0 from "./PlanningBoardSettings.vue?vue&type=style&index=0&id=686f2bd1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "686f2bd1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRadio } from 'vuetify/lib/components/VRadioGroup';
import { VRadioGroup } from 'vuetify/lib/components/VRadioGroup';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRadio,VRadioGroup,VRow,VSpacer})
